module.exports = __webpack_public_path__ + "img/retraitCVC.4c9ff035.jpg";